<template>
  <svg
    id="Layer_1"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 600 309"
    style="enable-background: new 0 0 600 309"
    xml:space="preserve"
  >
    <g>
      <path
        class="st0"
        d="M175.85,216.88c-24.57,0-44.56,19.99-44.56,44.56S151.28,306,175.85,306c24.57,0,44.56-19.99,44.56-44.56
      S200.42,216.88,175.85,216.88"
      />
      <path
        class="st1"
        d="M51.32,216.88c-24.57,0-44.56,19.99-44.56,44.56S26.75,306,51.32,306c24.57,0,44.56-19.99,44.56-44.56
      S75.89,216.88,51.32,216.88"
      />
      <path
        class="st2"
        d="M300.38,216.88c-24.57,0-44.56,19.99-44.56,44.56S275.81,306,300.38,306c24.57,0,44.56-19.99,44.56-44.56
      S324.95,216.88,300.38,216.88"
      />
      <path
        class="st3"
        d="M549.44,216.88c-24.57,0-44.56,19.99-44.56,44.56S524.87,306,549.44,306c24.57,0,44.56-19.99,44.56-44.56
      S574.01,216.88,549.44,216.88"
      />
      <path
        class="st4"
        d="M424.91,216.88c-24.57,0-44.57,19.99-44.57,44.56c0,24.57,19.99,44.56,44.56,44.56
      c24.57,0,44.56-19.99,44.56-44.56C469.47,236.87,449.49,216.88,424.91,216.88"
      />
      <path
        class="st5"
        d="M88.47,90.61c0-20.84-15.72-36.56-36.56-36.56c-20.84,0-36.56,15.72-36.56,36.56
      c0,20.83,15.72,36.56,36.56,36.56C72.74,127.17,88.47,111.44,88.47,90.61 M0.02,90.61c0-28.89,23.19-50.71,51.89-50.71
      c28.89,0,51.89,21.62,51.89,50.51v44.42c0,4.52-3.15,7.66-7.86,7.66c-4.91,0-7.86-3.14-7.86-7.66v-12.97h-0.79
      c-6.09,10.42-18.28,19.46-36.36,19.46C23.02,141.32,0.02,119.7,0.02,90.61"
      />
      <path
        class="st5"
        d="M212.69,90.61c0-20.84-15.72-36.56-36.56-36.56s-36.56,15.72-36.56,36.56c0,20.83,15.72,36.56,36.56,36.56
      S212.69,111.44,212.69,90.61 M144.29,174.14c-4.13-1.97-6.09-5.51-4.52-9.63c1.57-4.33,5.5-6.09,9.63-4.13
      c7.08,3.34,15.92,5.7,25.35,5.7c23.39,0,37.54-13.96,37.54-37.74v-6.49h-0.79c-6.09,10.42-18.28,19.46-36.36,19.46
      c-27.91,0-50.9-21.62-50.9-50.71c0-28.89,23.19-50.71,51.89-50.71c28.89,0,51.89,21.62,51.89,50.51v36.95
      c0,31.84-20.44,53.26-53.85,53.26C163.95,180.62,153.73,178.66,144.29,174.14"
      />
      <path
        class="st5"
        d="M336.91,90.61c0-20.84-15.72-36.56-36.56-36.56c-20.84,0-36.56,15.72-36.56,36.56
      c0,20.83,15.72,36.56,36.56,36.56C321.19,127.17,336.91,111.44,336.91,90.61 M248.47,90.61c0-28.89,23-50.71,51.89-50.71
      c28.89,0,51.89,21.81,51.89,50.71c0,28.89-23,50.71-51.89,50.71C271.46,141.32,248.47,119.5,248.47,90.61"
      />
      <path
        class="st5"
        d="M461.13,90.61c0-20.84-15.72-36.56-36.56-36.56c-20.84,0-36.56,15.72-36.56,36.56
      c0,20.83,15.72,36.56,36.56,36.56C445.41,127.17,461.13,111.44,461.13,90.61 M372.69,90.61c0-28.89,22.8-50.71,50.91-50.71
      c18.08,0,30.27,9.04,36.36,19.46h0.79V7.67c0-4.52,3.15-7.67,7.86-7.67c4.91,0,7.86,3.15,7.86,7.67V90.8
      c0,28.89-23,50.51-51.89,50.51C395.88,141.32,372.69,119.5,372.69,90.61"
      />
      <path
        class="st5"
        d="M585.36,90.61c0-20.84-15.72-36.56-36.56-36.56c-20.84,0-36.56,15.72-36.56,36.56
      c0,20.83,15.72,36.56,36.56,36.56C569.63,127.17,585.36,111.44,585.36,90.61 M496.91,90.61c0-28.89,23.19-50.71,51.89-50.71
      c28.89,0,51.89,21.62,51.89,50.51v44.42c0,4.52-3.15,7.66-7.86,7.66c-4.91,0-7.86-3.14-7.86-7.66v-12.97h-0.79
      c-6.09,10.42-18.28,19.46-36.36,19.46C519.91,141.32,496.91,119.7,496.91,90.61"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'Agoda',
}
</script>

<style scoped lang="scss">
.st0 {
  fill: #fcb615;
}
.st1 {
  fill: #ed353f;
}
.st2 {
  fill: #02af56;
}
.st3 {
  fill: #00a8df;
}
.st4 {
  fill: #a14699;
}
.st5 {
  fill: #595a5a;
}
</style>
